// Imported preliminary schedules preserve relative days in their source notes.
// Calendar dates, when defined, always take precedence.
export function relativeTaskRange(task) {
  if (task.startDate || task.endDate) return null;
  const match = /^Cronograma preliminar: dia (\d+) ao dia (\d+)\b/i.exec(task.notes || "");
  if (!match) return null;
  const first = Number(match[1]);
  const last = Number(match[2]);
  if (first < 1 || last < first || last - first + 1 !== Number(task.durationDays)) return null;
  return { first, last };
}

export function relativeScheduleDays(tasks) {
  if (!tasks.length || tasks.some(task => !relativeTaskRange(task))) return null;
  const total = Math.max(...tasks.map(task => relativeTaskRange(task).last));
  return Array.from({ length: total }, (_, i) => ({
    iso: `day-${i + 1}`, relativeDay: i + 1, label: "DIA", number: i + 1, weekend: false,
  }));
}

export function relativeTaskPosition(task, first, last) {
  const range = relativeTaskRange(task);
  if (!range || range.last < first || range.first > last) return null;
  const start = Math.max(first, range.first);
  const end = Math.min(last, range.last);
  return { left: `${((start - first) / (last - first + 1)) * 100}%`, width: `${((end - start + 1) / (last - first + 1)) * 100}%` };
}

export function relativeTaskLabel(task) {
  const range = relativeTaskRange(task);
  return range ? `Dia ${range.first} → Dia ${range.last} · ${task.durationDays} dias corridos` : null;
}
